import {useCallback, useState} from 'react';

import {useApi} from '~/modules/api';
import {RedemptionCollection} from '~/types';

export const useRedemptionCodeLookup = ({
  redemptionCode,
}: {
  redemptionCode: string;
}) => {
  const [downloadingUserInfoStatus, setDownloadingUserInfoStatus] = useState<
    'none' | 'requesting' | 'success' | 'error'
  >('none');
  const [downloadingUserInfoErrorMsg, setDownloadingUserInfoErrorMsg] =
    useState('');

  const [userData, setUserData] = useState<RedemptionCollection>();

  const api = useApi();
  const searchUserInfo = useCallback(async () => {
    try {
      if (
        downloadingUserInfoStatus === 'none' ||
        downloadingUserInfoStatus === 'error'
      ) {
        setDownloadingUserInfoStatus('requesting');
        setDownloadingUserInfoErrorMsg('');
        const {data} = await api.fetch({
          url: '/lunaclub/redemptionCodeLookup',
          method: 'POST',
          data: {redemptionCode: redemptionCode},
        });

        if (data.status !== 'success') {
          throw new Error(data.errorMessage);
        }
        setUserData(data.data.users);
        setDownloadingUserInfoStatus('success');
      }
    } catch (error) {
      setDownloadingUserInfoStatus('error');
      if (error instanceof Error) {
        setDownloadingUserInfoErrorMsg(error.message);
      }
    }
  }, [api, downloadingUserInfoStatus, redemptionCode]);
  return {
    downloadingUserInfoErrorMsg,
    downloadingUserInfoStatus,
    userData,
    searchUserInfo,
  };
};
